export const LEGACY_RUNTIME_MODE = 'legacy';
export const NATIVE_RUNTIME_MODE = 'native';
/**
 * Frontage evaluates the migration feature flag once per request and sets this
 * global. Never re-check that flag from runtime code: two checks can disagree
 * within a single page lifecycle and leave the page mixing both loaders.
 */
export const getRuntimeMode = () => window.__MONOCLE_RUNTIME_MODE__ === NATIVE_RUNTIME_MODE
    ? NATIVE_RUNTIME_MODE
    : LEGACY_RUNTIME_MODE;
